import getApiClient from '@/plugins/api'
import Vue from 'vue'

export default {

    loadSurveys() {
        const self = this;
        const api = getApiClient(self.$root.$store);

        self.search = {};

        self.$store.commit('startLoading')

        self.search.page = self.page
        self.search.itemsPerPage = self.perPage
        self.surveys = [];

        // GET
        api.get(`/surveys/received`, {
            params: self.search
        })
            .then((result) => {
                self.surveys = result.data['hydra:member'];
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    changePage: function(page) {
        this.page = page
    },

    goToSurvey: function(data) {
        this.$router.push({name: 'Responder Pesquisa de Satisfação', params: {id: data.id}})
    }
}
